import { render, staticRenderFns } from "./convert.vue?vue&type=template&id=87b551fa&"
import script from "./convert.js?vue&type=script&lang=js&"
export * from "./convert.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports